module.exports = __webpack_public_path__ + "fonts/Inter-400-latin-ext30.fad2a54.woff2";